<section class="procedure-report-view">
  <header class="report-header">
    <div class="header-icon"><mat-icon>healing</mat-icon></div>
    <div>
      <p class="eyebrow">Finalized procedure report</p>
      <h2 mat-dialog-title>{{ procedureName }}</h2>
      <p class="performed" *ngIf="procedure.performedDateTime">
        Performed {{ procedure.performedDateTime | date:'medium' }}
      </p>
    </div>
    <mat-chip class="final-chip">Finalized</mat-chip>
  </header>

  <div mat-dialog-content class="report-content">
    <mat-card class="report-section" *ngIf="outcome">
      <mat-card-header><mat-icon mat-card-avatar>task_alt</mat-icon><mat-card-title>Outcome</mat-card-title></mat-card-header>
      <mat-card-content>{{ outcome }}</mat-card-content>
    </mat-card>

    <mat-card class="report-section" *ngIf="complications.length">
      <mat-card-header><mat-icon mat-card-avatar>warning_amber</mat-icon><mat-card-title>Complications</mat-card-title></mat-card-header>
      <mat-card-content><ul><li *ngFor="let item of complications">{{ item }}</li></ul></mat-card-content>
    </mat-card>

    <mat-card class="report-section" *ngIf="followUps.length">
      <mat-card-header><mat-icon mat-card-avatar>event_repeat</mat-icon><mat-card-title>Follow-up</mat-card-title></mat-card-header>
      <mat-card-content><ul><li *ngFor="let item of followUps">{{ item }}</li></ul></mat-card-content>
    </mat-card>

    <mat-card class="report-section" *ngIf="notes.length">
      <mat-card-header><mat-icon mat-card-avatar>notes</mat-icon><mat-card-title>Clinical notes</mat-card-title></mat-card-header>
      <mat-card-content><p *ngFor="let note of notes">{{ note }}</p></mat-card-content>
    </mat-card>

    <div class="empty-state" *ngIf="!outcome && !complications.length && !followUps.length && !notes.length">
      <mat-icon>description</mat-icon><span>No additional narrative was recorded for this procedure.</span>
    </div>
  </div>

  <div mat-dialog-actions align="end"><button mat-flat-button color="primary" type="button" (click)="close()">Close</button></div>
</section>
